import { ethers } from "ethers";
import AroundPoolFactoryABI from "../abis/AroundPoolFactory.json";

export class AroundPoolFactoryContract {
  contract;
  constructor(contractAddress, providerOrSigner) {
    this.contract = new ethers.Contract(contractAddress, AroundPoolFactoryABI.abi, providerOrSigner);
  }
  async createPool(marketType, collateral, quest) {
    return await this.contract.createPool(Number(marketType), collateral, String(quest || ''));
  }
  async getMarketGroupLength(marketType) {
    return await this.contract.getMarketGroupLength(Number(marketType));
  }
  async marketId() {
    return await this.contract.marketId();
  }
  async indexMarketTypeData(marketType, index) {
    return await this.contract.indexMarketTypeData(Number(marketType), Number(index));
  }
  async getMarketPlace(id) {
    return await this.contract.getMarketPlace(ethers.toBigInt(id));
  }
  async getPoolInfo(thisMarketId) {
    return await this.contract.getPoolInfo(ethers.toBigInt(thisMarketId));
  }
  async aroundMarket() {
    return await this.contract.aroundMarket();
  }
}
